import { useTranslation } from "react-i18next";
import {Col, Empty, Row, Select, Spin, TableColumnsType} from "antd";
import TableWithTotals from "../../../../../../../components/table-with-totals/TableWithTotals";
import {BarStackedChartProps, ClassProps, DualChart,} from "../../../../../../../types/static-report";
import StatisticalReportCard from "../../../StatisticalReportCard";
import {createTableData, rateTransformData} from "../../tableConvertData";
import dayjs from "dayjs";
import {staticReportStore} from "../../../../../../../stores/stores";
import {
  exportRateClassAction,
  exportRateSequenceAction,
  exportRateUnitByClass,
  exportRateUnitByCourse,
  exportRateUnitByModule,
  exportRateUnitBySequence,
  exportUnitDiscuss,
  exportUnitReviewAndAccess,
} from "../../../../../../../service/statistical-report";
import {chartContentTypes, handleExportReport,} from "../../../../../../../utils/staticReport";

type Props = {
  loading: Record<string, boolean>;
  rateUnitByCourse: BarStackedChartProps[];
  rateUnitByModule: BarStackedChartProps[];
  rateUnitBySequence: BarStackedChartProps[];
  unitReviewAndAccess: DualChart[];
  rateSequenceAction: BarStackedChartProps[];
  rateClassAction: BarStackedChartProps[];
  unitDiscuss: BarStackedChartProps[];
  rateUnitByClass: BarStackedChartProps[];
  classList: ClassProps[];
};

const FeedbackAndEvaluationTableTab = (props: Props) => {
  const { t } = useTranslation();
  const {
    loading,
    rateUnitByCourse,
    rateUnitByModule,
    rateUnitBySequence,
    unitReviewAndAccess,
    rateSequenceAction,
    rateClassAction,
    unitDiscuss,
    rateUnitByClass,
    classList,
  } = props;
  const {filterValues, setFilterValues} = staticReportStore();

  const rateColumns: TableColumnsType<any> = [
    {
      title: t("1 sao", "1 sao"),
      dataIndex: "1 sao",
      key: "1 sao",

      width: 100,
    },
    {
      title: t("2 sao", "2 sao"),
      dataIndex: "2 sao",
      key: "2 sao",

      width: 100,
    },
    {
      title: t("3 sao", "3 sao"),
      dataIndex: "3 sao",
      key: "3 sao",

      width: 100,
    },
    {
      title: t("4 sao", "4 sao"),
      dataIndex: "4 sao",
      key: "4 sao",

      width: 100,
    },
    {
      title: t("5 sao", "5 sao"),
      dataIndex: "5 sao",
      key: "5 sao",

      width: 100,
    },
    {
      title: t("Tổng", "Tổng"),
      dataIndex: "total",
      key: "total",

      width: 80,
    },
  ];

  const rateCourseColumns: TableColumnsType<any> = [
    {
      title: t("Tên khoá học", "Tên khoá học"),
      dataIndex: "content",
      key: "content",
    },
    {
      title: t("1 sao", "1 sao"),
      dataIndex: "1 sao",
      key: "1 sao",

      width: 100,
    },
    {
      title: t("2 sao", "2 sao"),
      dataIndex: "2 sao",
      key: "2 sao",

      width: 100,
    },
    {
      title: t("3 sao", "3 sao"),
      dataIndex: "3 sao",
      key: "3 sao",

      width: 100,
    },
    {
      title: t("4 sao", "4 sao"),
      dataIndex: "4 sao",
      key: "4 sao",

      width: 100,
    },
    {
      title: t("5 sao", "5 sao"),
      dataIndex: "5 sao",
      key: "5 sao",

      width: 100,
    },
    {
      title: t("Tổng", "Tổng"),
      dataIndex: "total",
      key: "total",

      width: 80,
    },
  ];

  const handleContentTypesChange = (value: string) => {
    let courseStructureType = "";

    setFilterValues({
      courseStructureType: courseStructureType,
      moduleGroup: value,
    });
  };

  const exportPayload = {
    from: dayjs(filterValues.dateFrom).toISOString(),
    to: dayjs(filterValues.dateTo).toISOString(),
    courseLevelIds: filterValues?.courseLevelIds,
    industryGroupIds: filterValues?.industryGroupIds,
    courseIds: filterValues?.courseIds,
    universityIds: filterValues?.universityIds,
  };

  return (
    <div>
      <div className="chart-title">{t("Thống kê số lượng phản hồi", "Thống kê số lượng phản hồi")}</div>
      <Row gutter={{xs: 8, sm: 8, md: 16, lg: 16}}>
        <Col sm={{span: 24}} xs={{span: 24}}>
          <StatisticalReportCard
            chartName={t("Thống kê số lượng phản hồi theo thời gian", "Thống kê số lượng phản hồi theo thời gian")}
            content={
              <Spin spinning={loading.unitDiscuss}>
                {unitDiscuss.length > 0 ? (
                  <TableWithTotals
                    totalLabel={t("Tổng", "Tổng")}
                    data={createTableData(unitDiscuss).dataSource}
                    columns={[
                      {
                        title: t("Thời gian tạo", "Thời gian tạo"),
                        dataIndex: "name",
                        key: "name",
                      },
                      ...createTableData(unitDiscuss).columns,
                      {
                        title: t("Tổng", "Tổng"),
                        dataIndex: "total",
                        key: "total",

                      },
                    ]}
                    keyColumn="criteria"
                    height={275}
                    hasTotal={true}
                  />
                ) : (
                  <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
                )}
              </Spin>
            }
            exportOptions={
              unitDiscuss.length > 0
                ? [
                  {
                    label: "Excel",
                    action: () =>
                      handleExportReport(exportUnitDiscuss, t("Thống kê số lượng phản hồi theo thời gian", "Thống kê số lượng phản hồi theo thời gian"),
                        "excel",
                        {...exportPayload, timeUnit: filterValues.timeUnit}
                      ),
                  },
                  {
                    label: "PDF",
                    action: () =>
                      handleExportReport(exportUnitDiscuss, t("Thống kê số lượng phản hồi theo thời gian", "Thống kê số lượng phản hồi theo thời gian"),
                        "pdf",
                        {...exportPayload, timeUnit: filterValues.timeUnit}
                      ),
                  },
                ]
                : []
            }
          />
        </Col>
      </Row>

      <Row gutter={{xs: 8, sm: 8, md: 16, lg: 16}} className="mt-2">
        <Col sm={{span: 12}} xs={{span: 24}}>
          <StatisticalReportCard
            chartName={t("Thống kê số lượng phản hồi theo bài giảng", "Thống kê số lượng phản hồi theo bài giảng")}
            content={
              <Spin spinning={loading.rateSequenceAction}>
                {rateSequenceAction.length > 0 ? (
                  <TableWithTotals
                    totalLabel={t("Tổng", "Tổng")}
                    data={createTableData(rateSequenceAction).dataSource}
                    columns={[
                      {
                        title: t("Tên bài giảng", "Tên bài giảng"),
                        dataIndex: "name",
                        key: "name",
                      },
                      ...createTableData(rateSequenceAction).columns,
                      {
                        title: t("Tổng", "Tổng"),
                        dataIndex: "total",
                        key: "total",

                      },
                    ]}
                    keyColumn="criteria"
                    height={275}
                    hasTotal={true}
                  />
                ) : (
                  <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
                )}
              </Spin>
            }
            exportOptions={
              rateSequenceAction.length > 0
                ? [
                  {
                    label: "Excel",
                    action: () =>
                      handleExportReport(exportRateSequenceAction, t("Thống kê số lượng phản hồi theo bài giảng", "Thống kê số lượng phản hồi theo bài giảng"),
                        "excel",
                        exportPayload
                      ),
                  },
                  {
                    label: "PDF",
                    action: () =>
                      handleExportReport(exportRateSequenceAction, t("Thống kê số lượng phản hồi theo bài giảng", "Thống kê số lượng phản hồi theo bài giảng"),
                        "pdf",
                        exportPayload
                      ),
                  },
                ]
                : []
            }
          />
        </Col>
        <Col sm={{span: 12}} xs={{span: 24}}>
          <StatisticalReportCard
            chartName={t("Thống kê số lượng phản hồi theo lớp", "Thống kê số lượng phản hồi theo lớp")}
            content={
              <Spin spinning={loading.rateClassAction}>
                {rateClassAction.length > 0 ? (
                  <TableWithTotals
                    totalLabel={t("Tổng", "Tổng")}
                    data={createTableData(rateClassAction).dataSource}
                    columns={[
                      {
                        title: t("Tên lớp", "Tên lớp"),
                        dataIndex: "name",
                        key: "name",
                      },
                      ...createTableData(rateClassAction).columns,
                      {
                        title: t("Tổng", "Tổng"),
                        dataIndex: "total",
                        key: "total",

                      },
                    ]}
                    keyColumn="criteria"
                    height={275}
                    hasTotal={true}
                  />
                ) : (
                  <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
                )}
              </Spin>
            }
            exportOptions={
              rateClassAction.length > 0
                ? [
                  {
                    label: "Excel",
                    action: () =>
                      handleExportReport(exportRateClassAction, t("Thống kê số lượng phản hồi theo lớp", "Thống kê số lượng phản hồi theo lớp"),
                        "excel",
                        exportPayload
                      ),
                  },
                  {
                    label: "PDF",
                    action: () =>
                      handleExportReport(exportRateClassAction, t("Thống kê số lượng phản hồi theo lớp", "Thống kê số lượng phản hồi theo lớp"),
                        "pdf",
                        exportPayload
                      ),
                  },
                ]
                : []
            }
          />
        </Col>
      </Row>

      <div className="chart-title">{t("Thống kê số lượng đánh giá", "Thống kê số lượng đánh giá")}</div>
      <Col span={24}>
        <StatisticalReportCard
          chartName={t("Số lượng đánh giá theo thời gian", "Số lượng đánh giá theo thời gian")}
          content={
            <Spin spinning={loading.unitReviewAndAccess}>
              {unitReviewAndAccess.length > 0 ? (
                <TableWithTotals
                  totalLabel={t("Tổng", "Tổng")}
                  data={unitReviewAndAccess?.map((it) => ({
                    ...it,
                    total: it?.columnValue + it?.lineValue,
                  }))}
                  columns={[
                    {
                      title: t("Ngày làm đánh giá", "Ngày làm đánh giá"),
                      dataIndex: "criteria",
                      key: "criteria",
                    },
                    {
                      title: t("Lượng truy cập", "Lượng truy cập"),
                      dataIndex: "lineValue",
                      key: "lineValue",

                    },
                    {
                      title: t("Lượng làm đánh giá", "Lượng làm đánh giá"),
                      dataIndex: "columnValue",
                      key: "columnValue",

                    },
                    {
                      title: t("Tổng", "Tổng"),
                      dataIndex: "total",
                      key: "total",

                    },
                  ]}
                  keyColumn="criteria"
                  height={275}
                  hasTotal={true}
                />
              ) : (
                <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
              )}
            </Spin>
          }
          moreOption={
            <div>
              <Select
                value={filterValues?.moduleGroup}
                style={{width: 180}}
                options={chartContentTypes.filter(
                  (item) => item.value !== "5" && item.value !== "6"
                )}
                onSelect={(value) => {
                  handleContentTypesChange(value);
                }}
              />
            </div>
          }
          exportOptions={
            unitReviewAndAccess.length > 0
              ? [
                {
                  label: "Excel",
                  action: () =>
                    handleExportReport(exportUnitReviewAndAccess, t("Số lượng đánh giá theo thời gian", "Số lượng đánh giá theo thời gian"),
                      "excel",
                      {
                        ...exportPayload,
                        timeUnit: filterValues.timeUnit,
                        moduleGroup: filterValues?.moduleGroup,
                      }
                    ),
                },
                {
                  label: "PDF",
                  action: () =>
                    handleExportReport(exportUnitReviewAndAccess, t("Số lượng đánh giá theo thời gian", "Số lượng đánh giá theo thời gian"),
                      "pdf",
                      {
                        ...exportPayload,
                        timeUnit: filterValues.timeUnit,
                        moduleGroup: filterValues?.moduleGroup,
                      }
                    ),
                },
              ]
              : []
          }
        />
      </Col>

      <Row gutter={{xs: 8, sm: 8, md: 16, lg: 16}} className="mt-2">
        <Col sm={{span: 12}} xs={{span: 24}}>
          <StatisticalReportCard
            chartName={t("Tỷ lệ kết quả làm đánh giá", "Tỷ lệ kết quả làm đánh giá")}
            content={
              <Spin spinning={loading.rateUnitByModule}>
                {rateUnitByModule.length > 0 ? (
                  <TableWithTotals
                    totalLabel={t("Tổng", "Tổng")}
                    data={rateTransformData(rateUnitByModule)}
                    columns={[
                      {
                        title: t("Nội dung", "Nội dung"),
                        dataIndex: "content",
                        key: "content",
                      },
                      ...rateColumns,
                    ]}
                    keyColumn="content"
                    height={275}
                    hasTotal={true}
                    calculatePercentage={true}
                    width={500}
                  />
                ) : (
                  <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
                )}
              </Spin>
            }
            exportOptions={
              rateUnitByModule.length > 0
                ? [
                  {
                    label: "Excel",
                    action: () =>
                      handleExportReport(exportRateUnitByModule, t("Tỷ lệ kết quả làm đánh giá", "Tỷ lệ kết quả làm đánh giá"),
                        "excel",
                        exportPayload
                      ),
                  },
                  {
                    label: "PDF",
                    action: () =>
                      handleExportReport(exportRateUnitByModule, t("Tỷ lệ kết quả làm đánh giá", "Tỷ lệ kết quả làm đánh giá"),
                        "pdf",
                        exportPayload
                      ),
                  },
                ]
                : []
            }
          />
        </Col>
        <Col sm={{span: 12}} xs={{span: 24}}>
          <StatisticalReportCard
            chartName={t("Tỷ lệ kết quả đánh giá khoá học", "Tỷ lệ kết quả đánh giá khoá học")}
            content={
              <Spin spinning={loading.rateUnitByCourse}>
                {rateUnitByCourse.length > 0 ? (
                  <TableWithTotals
                    totalLabel={t("Tổng", "Tổng")}
                    data={rateTransformData(rateUnitByCourse)}
                    columns={rateCourseColumns}
                    keyColumn="content"
                    height={275}
                    hasTotal={true}
                    calculatePercentage={true}
                    width={500}
                  />
                ) : (
                  <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
                )}
              </Spin>
            }
            exportOptions={
              rateUnitByCourse.length > 0
                ? [
                  {
                    label: "Excel",
                    action: () =>
                      handleExportReport(exportRateUnitByCourse, t("Tỷ lệ kết quả đánh giá khoá học", "Tỷ lệ kết quả đánh giá khoá học"),
                        "excel",
                        exportPayload
                      ),
                  },
                  {
                    label: "PDF",
                    action: () =>
                      handleExportReport(exportRateUnitByCourse, t("Tỷ lệ kết quả đánh giá khoá học", "Tỷ lệ kết quả đánh giá khoá học"),
                        "pdf",
                        exportPayload
                      ),
                  },
                ]
                : []
            }
          />
        </Col>
      </Row>

      <Row gutter={{xs: 8, sm: 8, md: 16, lg: 16}} className="mt-2">
        <Col sm={{span: 12}} xs={{span: 24}}>
          <StatisticalReportCard
            chartName={t("Tỷ lệ kết quả đánh giá theo bài giảng", "Tỷ lệ kết quả đánh giá theo bài giảng")}
            content={
              <Spin spinning={loading.rateUnitBySequence}>
                {rateUnitBySequence.length > 0 ? (
                  <TableWithTotals
                    totalLabel={t("Tổng", "Tổng")}
                    data={rateTransformData(rateUnitBySequence)}
                    columns={[
                      {
                        title: t("Tên bài giảng", "Tên bài giảng"),
                        dataIndex: "content",
                        key: "content",
                      },
                      ...rateColumns,
                    ]}
                    keyColumn="content"
                    height={275}
                    hasTotal={true}
                    calculatePercentage={true}
                    width={500}
                  />
                ) : (
                  <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
                )}
              </Spin>
            }
            exportOptions={
              rateUnitBySequence.length > 0
                ? [
                  {
                    label: "Excel",
                    action: () =>
                      handleExportReport(exportRateUnitBySequence, t("Tỷ lệ kết quả đánh giá theo bài giảng", "Tỷ lệ kết quả đánh giá theo bài giảng"),
                        "excel",
                        exportPayload
                      ),
                  },
                  {
                    label: "PDF",
                    action: () =>
                      handleExportReport(exportRateUnitBySequence, t("Tỷ lệ kết quả đánh giá theo bài giảng", "Tỷ lệ kết quả đánh giá theo bài giảng"),
                        "pdf",
                        exportPayload
                      ),
                  },
                ]
                : []
            }
          />
        </Col>
        <Col sm={{span: 12}} xs={{span: 24}}>
          <StatisticalReportCard
            chartName={t("Tỷ lệ kết quả đánh giá học liệu theo lớp", "Tỷ lệ kết quả đánh giá học liệu theo lớp")}
            content={
              <Spin spinning={loading.rateUnitByClass}>
                {rateUnitByClass.length > 0 ? (
                  <TableWithTotals
                    totalLabel={t("Tổng", "Tổng")}
                    data={rateTransformData(rateUnitByClass)}
                    columns={[
                      {
                        title: t("Tên học liệu", "Tên học liệu"),
                        dataIndex: "content",
                        key: "content",
                      },
                      ...rateColumns,
                    ]}
                    keyColumn="content"
                    height={275}
                    hasTotal={true}
                    calculatePercentage={true}
                    width={500}
                  />
                ) : (
                  <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
                )}
              </Spin>
            }
            moreOption={
              <div>
                <Select
                  showSearch
                  placeholder={t("Chọn lớp", "Chọn lớp")}
                  style={{width: 170}}
                  defaultValue={filterValues?.classId}
                  onSelect={(value) => {
                    setFilterValues({classId: value});
                  }}
                  options={classList}
                />
              </div>
            }
            exportOptions={
              rateUnitByClass.length > 0
                ? [
                  {
                    label: "Excel",
                    action: () =>
                      handleExportReport(exportRateUnitByClass, t("Tỷ lệ kết quả đánh giá học liệu theo lớp", "Tỷ lệ kết quả đánh giá học liệu theo lớp"),
                        "excel",
                        {...exportPayload, classId: filterValues?.classId}
                      ),
                  },
                  {
                    label: "PDF",
                    action: () =>
                      handleExportReport(exportRateUnitByClass, t("Tỷ lệ kết quả đánh giá học liệu theo lớp", "Tỷ lệ kết quả đánh giá học liệu theo lớp"),
                        "pdf",
                        {...exportPayload, classId: filterValues?.classId}
                      ),
                  },
                ]
                : []
            }
          />
        </Col>
      </Row>
    </div>
  );
};

export default FeedbackAndEvaluationTableTab;
